import styled from 'styled-components';

import { WithThemeProps } from '../../styles';


const Button = styled.div`
	position: relative;
	max-width: 100%;
	padding: 6px 16px;
	color: #fff;
	min-height: 36px;
	display: inline-flex;
	align-items: center;
	border-radius: 1px;
	box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 1px 0px, rgba(0, 0, 0, 0.05) 0px 0px 1px 0px;

	${(p: WithThemeProps) => p.theme && `
		background-color: ${p.theme.palette.accentPrimary};
	`}
`;

const ButtonContent = styled.div`
	position: relative;
	width: 100%;
	display: inline-flex;
	align-items: center;
	justify-content: center;
`;

const IconLayout = styled.div`
	display: inline-flex;
	align-items: center;
	margin-right: -4px;
`;

const Sign = styled.span`
	margin-right: 16px;
`;

const Separator = styled.span`
	margin-top: -3px;
`;

const ItemIconLayout = styled.div`
	display: flex;
	align-items: center;
	margin-right: 16px;
`;

export {
	Button,
	ButtonContent,
	IconLayout,
	Sign,
	Separator,
	ItemIconLayout,
};
